import { APP_HOST } from './consts/domains';

export function isAppHost(hostname: string): boolean {
  return hostname.toLowerCase() === APP_HOST;
}
